// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ImportProjectSchema } from './v1/import/projectSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const listImportProjectsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
  id: z.number().int().describe("Workspace id in the external system"),
});

export const listImportProjectsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of projects
 */
export const listImportProjects200Schema = z.array(z.lazy(() => v1ImportProjectSchema));

/**
 * @description Workspace not found
 */
export const listImportProjects404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const listImportProjectsQueryResponseSchema = z.lazy(() => listImportProjects200Schema);
